
import { Component, Vue, Prop } from "vue-property-decorator";
import Axios from "axios";
import { API_STORE } from "@/config";
import {
  validateChildrenComponentForms,
  getAPIAuthorizedHeader,
} from "@/services/common";
import { Credential } from "@/models/common";
import Swal from "sweetalert2";

@Component({})
export default class UpdateClientComponent extends Vue {
  public showPassword = false;
  public editing = false;
  public credential = new Credential();
  public disableSubmitbutton = false;

  get user() {
    return this.$store.state.user;
  }
  get clientId() {
    return this.$store.state.clientId;
  }
  set user(data) {
    this.$store.state.user = data;
  }
  get imageFile() {
    return this.$store.state.imageFile;
  }
  set imageFile(data) {
    this.$store.state.imageFile = data;
  }
  get imageSrc() {
    return this.$store.state.imageSrc;
  }
  set imageSrc(data) {
    this.$store.state.imageSrc = data;
  }
  get emailOTPSent() {
    return this.$store.state.emailOTPSent;
  }

  get phoneOTPSent() {
    return this.$store.state.phoneOTPSent;
  }
  set emailOTPSent(d) {
    this.$store.state.emailOTPSent = d;
  }
  set phoneOTPSent(d) {
    this.$store.state.phoneOTPSent = d;
  }

  get emailExist() {
    return this.$store.state.emailExist;
  }

  set emailExist(data) {
    this.$store.state.emailExist = data;
  }
  get userNameExist() {
    return this.$store.state.userNameExist;
  }

  set userNameExist(data) {
    this.$store.state.userNameExist = data;
  }
  get phoneExist() {
    return this.$store.state.phoneExist;
  }
  set phoneExist(data) {
    this.$store.state.phoneExist = data;
  }

  get subdomainExist() {
    return this.$store.state.subdomainExist;
  }
  set subdomainExist(data) {
    this.$store.state.subdomainExist = data;
  }

  async cancelForm() {
    await this.$store.dispatch("cancelUserForm");
    this.$router.go(-1);
  }

  public async fileChangeEvent(event) {
    let file = event.target.files[0];
    file["categoryName"] = "profile" + "." + file.name.split(".").pop();
    this.imageFile.push(file);
    await this.$store.dispatch("updateStore", {
      imageSrc: URL.createObjectURL(event.target.files[0]),
      imageFile: this.imageFile,
    });
  }

  public async saveInformation() {
    this.disableSubmitbutton = true;
    this.$showLoader(true);
    /**
     * This will execute the validateAll fuction in all the child component
     * returning the state of validation whether it is valid or invalid
     */
    let childrensValid = await validateChildrenComponentForms(this.$children);
    let formValid = await this.$validator.validateAll();
    if (!formValid || !childrensValid) {
      this.$showLoader(false);
      this.disableSubmitbutton = false;
      this.$snotify.error("Please fix the validation errors!");
      return { status: false };
    }

    this.user.domain = this.user.domain.toLowerCase();
    if (!this.editing)
      this.user.subdomain = this.getSubdomainName(this.user.domain);
    if (!this.editing) this.user.parentId = this.$userId;
    this.user["clientId"] = this.clientId;
    this.user["addedBy"] = this.user.addedBy ? this.user.addedBy : this.$userId;
    this.user["updatedBy"] = this.$userId;
    this.user["isClient"] = true;
    this.user["userId"] = this.editing ? this.$route.query.userId : null;
    this.user["edit"] = this.editing;
    await this.$store.dispatch("updateStore", { user: this.user });
    let response = null;
    if (this.editing) {
      let formData = new FormData();
      for (let i = 0; i < this.imageFile.length; i++) {
        let file = this.imageFile[i];
        if (file.categoryName.startsWith("profile"))
          formData.append("file", file, file.categoryName);
      }
      formData.append("jsonData", JSON.stringify(this.user));
      response = await Axios.post(API_STORE.ADMIN + "updateClient", formData, {
        headers: getAPIAuthorizedHeader(),
      });
    } else {
      response = await Axios.post(
        API_STORE.CONFIG + "checkUserDuplicateFieldsAndSendOTP",
        this.user,
        { headers: getAPIAuthorizedHeader() }
      );
    }
    this.disableSubmitbutton = false;
    this.$showLoader(false);
    if (response) {
      if (response.data.duplicates) {
        await this.$store.dispatch("updateStore", {
          emailExist: response.data.duplicates.emailExists,
          subdomainExist: response.data.duplicates.subdomainExists,
          phoneExist: response.data.duplicates.phoneExists,
          userNameExist: response.data.duplicates.userNameExists,
        });
        document
          .querySelector("input[name=email]")
          .scrollIntoView({ behavior: "smooth" });
          return { status: false };
      } else if (response.data.emailOTPSent || response.data.phoneOTPSent) {
        await this.$store.dispatch("updateStore", {
          emailOTPSent: response.data.emailOTPSent,
          phoneOTPSent: response.data.phoneOTPSent,
        });
        document
          .querySelector("input[name=email]")
          .scrollIntoView({ behavior: "smooth" });
          return { status: false };
      } else {
        Swal.fire({
          position: "center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: true,
        });
        this.$emit("updateClient", true);
        return { status: true };
      }
    }
  }

  public getSubdomainName(url) {
    if (!url.includes("https://")) url = `https://${url}`;
    let values = url.split(".");
    let delimeterValue = 8;
    return values[0].substring(delimeterValue, values[0].length);
  }

  public deleteImage() {
    if (this.imageFile.length > 0) {
      this.imageFile.forEach((file, i) => {
        if (file.categoryName.startsWith("profile")) {
          let remoteSrc = !!this.user.imageInfo;
          if (remoteSrc) this.user["imageDeleted"] = true;
          this.imageFile.splice(i, 1);
          this.$store.dispatch("updateStore", {
            imageFile: this.imageFile,
            imageSrc: null,
          });
        }
      });
    }
  }

  public async resendOPTToVerifyCredential(type, value) {
    if (type && value) {
      let fieldName = type == "email" ? "emailOTPSent" : "phoneOTPSent";
      this.$showLoader(true);
      let response = await Axios.post(
        API_STORE.AUTHENTICATION + "sentOPTToVerifyCredential",
        { type: type, value: value, retry: true },
        { headers: getAPIAuthorizedHeader() }
      );
      this.$showLoader(false);
      if (response) {
        await this.$store.dispatch("updateStore", {
          [fieldName]: true,
        });
        if (!this.$route.query.userId)
          Swal.fire({
            position: "center",
            icon: "success",
            title: "OTP has been resend successfully",
            showConfirmButton: true,
          });
      }
    }
  }

  public async verifyOPTToValidateCredential(type, otp, value) {
    if (type && otp && otp != "" && value) {
      this.$showLoader(true);
      let response = await Axios.post(
        API_STORE.AUTHENTICATION + "verifyOPTToValidateCredential",
        { type: type, value: value, otp: otp },
        { headers: getAPIAuthorizedHeader() }
      );
      this.$showLoader(false);
      if (response) {
        let otpSentObj = {};
        if (type == "email") {
          otpSentObj = { emailOTPSent: null };
          this.user.isEmailVerified = true;
          this.$snotify.success("Email has been verified successfully");
        } else {
          otpSentObj = { phoneOTPSent: null };
          this.user.isPhoneVerified = true;
          this.$snotify.success("Phone has been verified successfully");
        }
        await this.$store.dispatch("updateStore", {
          user: this.user,
          ...otpSentObj,
        });
      }
    }
  }

  public async getClient() {
    let info = this.user.imageInfo;
    this.$store.dispatch("updateStore", {
      user: this.user,
      imageSrc:
        info.length > 0 && info[0].path
          ? this.$AWS_S3_URL + info[0].path
          : null,
    });
  }

  mounted() {
    this.editing = this.$route.query.userId ? true : false;
    this.getClient();
  }
}
